/* Litborne drawer suggester — under each cart line, offer same-artwork pieces not yet in cart.
 * Data: assets/lb-set-index.json. Injected rows: <tr class="lb-sgl"> (NO data-key, NO cart-items__table-row
 * class) so reconcileCartUI row counting and summer26 decorateCart never see them.
 * Survival model: drawer DOM is morphed/replaced by theme sections, lb-set recipes and reconcileCartUI —
 * so injection is idempotent and re-runs (debounced) off cart:update + a body MutationObserver.
 * Re-entry does ZERO DOM writes when rows are already present (avoids observer ping-pong). */
(function () {
  'use strict';
  var SELF = document.currentScript;
  var IDX = null, IDX_URL = SELF ? SELF.getAttribute('data-lb-index') : null, PCT = 50, busy = false, t = null;
  var NEXT_KEY = 'lb:sgl:next';
  var ORDER = ['Wallet','Long Wallet','Mini Satchel','Mini Wallet','Circle Crossbody Bag','Leather Handbag','Small Leather Handbag','Bat Wing Handbag','Leather Tote Bag','Leather Backpack','Eclipse Makeup Bag','Makeup Bag','Envelope Chain Crossbody Bag'];
  function ordIdx(ty){var i=ORDER.indexOf(ty);return i<0?500:(ty==='Envelope Chain Crossbody Bag'?999:i);}
  var SGL_SHORT={'Bat Wing Handbag':'Bat Wing Bag','Leather Handbag':'Handbag','Small Leather Handbag':'Small Handbag','Leather Tote Bag':'Tote Bag','Leather Backpack':'Backpack','Mini Satchel':'Mini Satchel','Circle Crossbody Bag':'Circle Crossbody','Envelope Chain Crossbody Bag':'Envelope Crossbody','Eclipse Makeup Bag':'Makeup Bag','Makeup Bag':'Makeup Bag','Long Wallet':'Long Wallet','Mini Wallet':'Mini Wallet','Wallet':'Wallet'};
  var SGL_DESC={'Bat Wing Handbag':'Wings, handles and a strap','Wallet':'For cards, cash and coins','Mini Wallet':'For cards and cash','Long Wallet':'For cards, cash and phone','Mini Satchel':'For the light days','Circle Crossbody Bag':'Hands-free carry','Envelope Chain Crossbody Bag':'For the evenings','Eclipse Makeup Bag':'Brushes, liner, lipstick','Makeup Bag':'Brushes, liner, lipstick','Leather Tote Bag':'Carries the whole day','Leather Backpack':'Both shoulders, all day','Small Leather Handbag':'The smaller stage','Leather Handbag':'The centerpiece'};

  function cur() { var c = (window.Shopify && window.Shopify.currency) || {}; return { a: c.active || 'USD', r: parseFloat(c.rate || '1') || 1 }; }
  function fmt(usd) {
    var c = cur();
    if (c.a === 'USD') return '$' + usd.toFixed(2);
    try {
      if (c.a === 'VND') return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(usd * c.r) + '<span class="lb-dong">\u0111</span>';
      return new Intl.NumberFormat('en', { style: 'currency', currency: c.a, maximumFractionDigits: 2 }).format(usd * c.r);
    } catch (e) { return '$' + usd.toFixed(2); }
  }
  function half(n) {
    if (cur().a === 'USD') return Math.round(n * (100 - PCT)) / 100;
    /* non-USD: round o khong gian presentment (VND 0 le) de khop phep giam cua Shopify */
    var c = cur(), p = n * c.r;
    var hp = (c.a === 'VND') ? Math.round(p * (100 - PCT) / 100) : Math.round(p * (100 - PCT)) / 100;
    return hp / c.r;
  }

  function ensureCss() {
    if (document.getElementById('lb-sgl-css')) return;
    var s = document.createElement('style');
    s.id = 'lb-sgl-css';
    s.textContent =
      '.lb-sgl td{padding:0 0 10px;}' +
      '.lb-sgl__box{margin:2px 0;border:1px solid rgba(201,165,90,.35);background:rgba(201,165,90,.06);border-radius:8px;padding:10px 12px;}' +
      '.lb-sgl__chip{background:none;border:0;color:#c9a55a;font-family:"Courier Prime",monospace;font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;padding:2px 0;display:block;width:100%;text-align:left;}' +
      '.lb-sgl__row{display:flex;align-items:center;gap:10px;margin-top:10px;}' +
      '.lb-sgl__thumb{width:44px;height:44px;flex:0 0 auto;background:rgba(26,26,26,.07);border-radius:6px;display:flex;align-items:center;justify-content:center;overflow:hidden;}' +
      '.lb-sgl__thumb img{max-width:86%;max-height:86%;object-fit:contain;}' +
      '.lb-sgl__mid{flex:1 1 auto;min-width:0;}' +
      '.lb-sgl__name{font-family:"Courier Prime",monospace;font-size:10.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#1a1a1a;margin:0;}' +
      '.lb-sgl__desc{font-family:"Cormorant Garamond",serif!important;font-size:12.5px;color:rgba(26,26,26,.6);margin:2px 0 0;text-transform:none!important;letter-spacing:0!important;line-height:1.3;}' +
      '.lb-dong{font-size:.55em;vertical-align:super;text-decoration:underline;text-underline-offset:1px;margin-left:1px;line-height:0;text-transform:lowercase!important;}' +
      '.lb-sgl__price{display:flex;flex-direction:column;align-items:flex-end;flex:0 0 auto;text-transform:none!important;}' +
      '.lb-sgl__pay{font-family:"Cormorant Garamond",serif;font-size:14px;color:#c9a55a;white-space:nowrap;}' +
      '.lb-sgl__was{font-family:"Cormorant Garamond",serif;font-size:11px;color:rgba(26,26,26,.4);white-space:nowrap;}' +
      '.lb-sgl__add{background:transparent;border:1px solid #c9a55a;color:#c9a55a;padding:7px 14px;font-family:"Courier Prime",monospace;font-size:9px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;cursor:pointer;flex:0 0 auto;border-radius:2px;}' +
      '.lb-sgl__add[disabled]{opacity:.55;cursor:wait;}' +
      '.lb-sgl__add.is-added{color:#6fbf73;border-color:#6fbf73;}' +
      /* --- compact drawer footer --- */
      '.cart-drawer__summary{padding-top:10px!important;padding-bottom:10px!important;}' +
      '.cart-drawer__summary .cart-actions{margin:0;}' +
      '.cart-drawer__summary .cart-discount details{margin:0;}' +
      '.cart-drawer__summary .details-content{margin:0;padding:0;}' +
      '.cart-drawer__summary summary.cart-discount__summary{display:none;}' +
      '.cart-drawer__summary cart-discount-component{display:flex;flex-wrap:wrap;align-items:center;gap:6px 10px;}' +
      '.cart-drawer__summary .cart-discount__content{display:none;flex:1 1 100%;order:8;margin:6px 0 0;}' +
      '.cart-drawer__summary.lb-cf-open .cart-discount__content{display:flex;}' +
      '.cart-drawer__summary .cart-discount__error{flex:1 1 100%;order:9;}' +
      '.cart-drawer__summary .cart-discount__codes{margin:0;padding:0;display:inline-flex;gap:6px;list-style:none;}' +
      '.cart-drawer__summary .cart-discount__pill{display:inline-flex;align-items:center;gap:8px;margin:0;}' +
      '.lb-chipamt{color:#c9a55a;font-size:12px;white-space:nowrap;}' +
      '.lb-cf-addcode{background:none;border:0;color:rgba(26,26,26,.55);font-family:"Courier Prime",monospace;font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;padding:2px 0;text-decoration:underline;text-underline-offset:2px;margin-left:auto;}' +
      '.cart-drawer__summary .cart-totals__original-container:has(.cart-discounts li) > .cart-totals__original:first-child{display:none;}' +
      '.cart-drawer__summary ul.cart-discounts{display:none;}' +
      '.cart-drawer__summary .cart-totals__original-container{padding-top:6px;}' +
      '.lb-strike{text-decoration:line-through;opacity:.45;margin-right:8px;font-size:.9em;}' +
      '.cart-drawer__summary .cart-totals__tax-note{margin:2px 0 0;}' +
      '.cart-drawer__summary .cart-totals__tax-note small{font-size:10px;opacity:.6;}' +
      '.cart-drawer__summary + .cart__ctas, .cart-drawer__summary .cart__ctas{margin-top:8px;}';
    document.head.appendChild(s);
  }

  function sectionIds() {
    var s = [];
    document.querySelectorAll('cart-items-component[data-section-id],cart-icon-component[data-section-id],cart-drawer-component[data-section-id]')
      .forEach(function (el) { if (s.indexOf(el.dataset.sectionId) < 0) s.push(el.dataset.sectionId); });
    return s;
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (sid) {
      var html = sections[sid];
      if (typeof html !== 'string' || !html.length) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      document.querySelectorAll('[data-section-id="' + sid + '"]').forEach(function (el) {
        var src = parsed.querySelector('[data-section-id="' + sid + '"]') || parsed.body.firstElementChild;
        if (src) el.innerHTML = src.innerHTML;
      });
    });
  }

  function addItem(vid, btn, src) {
    btn.disabled = true; btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: vid, quantity: 1, properties: { _attach_source: src || 'Cart drawer \u2014 suggestion' } }],
        sections: sectionIds().join(','),
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.message || 'add failed');
        applySections(data.sections);
        /* dispatch PHAI kem itemCount — thieu la theme cart-icon coi la 0 va an badge */
        fetch('/cart.js?_lbn=' + Date.now(), { cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            var n = (cart && typeof cart.item_count === 'number') ? cart.item_count : null;
            if (n !== null) { try { window.sessionStorage.setItem('cart-count', JSON.stringify({ value: n, timestamp: Date.now() })); } catch (e) { } }
            var ev = new Event('cart:update', { bubbles: true });
            ev.detail = { resource: data, sourceId: 'lb-drawer-suggest', data: { source: 'lb-drawer-suggest', itemCount: n === null ? undefined : n, sections: data.sections || {} } };
            document.dispatchEvent(ev);
          })
          .catch(function () { });
      })
      .catch(function (e) { console.error('lb-sgl add', e); btn.disabled = false; btn.textContent = 'Add'; });
  }

  function getCart() {
    return fetch('/cart.js?_lbsgl=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Fallback "same shelf": cung collection genre, khac loai tui, khac artwork */
  function shelfCands(me, handle, inCart, used) {
    if (!me.cl || !me.cl.length || !IDX.cols) return [];
    var pool = [];
    Object.keys(IDX.byHandle).forEach(function (h) {
      var e = IDX.byHandle[h];
      if (h === handle || e.f === me.f || e.ty === me.ty) return;
      if (inCart[h] || used[h]) return;
      if (!e.cl || !e.cl.some(function (ci) { return me.cl.indexOf(ci) >= 0; })) return;
      var m = (IDX.fams[e.f] || []).filter(function (x) { return x.h === h; })[0];
      if (m) pool.push({ h: m.h, t: m.t, ty: m.ty, vid: m.vid, p: m.p, img: m.img, f: e.f });
    });
    for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp; }
    var picks = [], seenTy = {}, seenFam = {};
    pool.forEach(function (m) { if (picks.length < 2 && !seenTy[m.ty] && !seenFam[m.f]) { picks.push(m); seenTy[m.ty] = 1; seenFam[m.f] = 1; } });
    pool.forEach(function (m) { if (picks.length < 2 && !seenTy[m.ty] && picks.indexOf(m) < 0) { picks.push(m); seenTy[m.ty] = 1; } });
    pool.forEach(function (m) { if (picks.length < 2 && picks.indexOf(m) < 0) picks.push(m); });
    picks.forEach(function (m) { used[m.h] = 1; });
    return picks;
  }
  /* FIX lech gia voi cart (14/08) — cung co che voi lb-set-picker: gia that per-variant
     tu /products/<h>.js, cache sessionStorage 'lb:pres:' dung chung 2 file; m.p = real/rate.
     USD return som, khong fetch gi. */
  function fixPresRows() {
    var c = cur(); if (c.a === 'USD') return;
    var byH = {};
    document.querySelectorAll('.lb-sgl__row').forEach(function (row) {
      var m = row.__lbM;
      if (m && m.h && m.vid) (byH[m.h] = byH[m.h] || []).push(row);
    });
    Object.keys(byH).forEach(function (h) {
      function apply(map) {
        byH[h].forEach(function (row) {
          var m = row.__lbM, minor = map && map[String(m.vid)];
          if (typeof minor !== 'number' || !(minor > 0)) return;
          m.p = (minor / 100) / c.r;
          var pay = row.querySelector('.lb-sgl__pay'), was = row.querySelector('.lb-sgl__was');
          if (pay) pay.innerHTML = fmt(half(m.p));
          if (was) was.innerHTML = fmt(m.p);
        });
      }
      var key = 'lb:pres:' + c.a + ':' + h, cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { }
      if (cached) { apply(cached); return; }
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pj) {
        if (!pj || !pj.variants) return;
        var map = {}; pj.variants.forEach(function (v) { map[String(v.id)] = v.price; });
        try { sessionStorage.setItem(key, JSON.stringify(map)); } catch (e) { }
        apply(map);
      }).catch(function () { });
    });
  }
  function inject() {
    if (busy || !IDX) return;
    var tbody = document.querySelector('cart-drawer-component .cart-items__table tbody');
    if (!tbody) return;
    var lines = tbody.querySelectorAll('tr.cart-items__table-row[data-key]');
    if (!lines.length) { return; }
    /* idempotence probe: every line already resolved (has marker sibling or marked no-fam)? */
    var pending = false;
    lines.forEach(function (line) {
      var key = line.getAttribute('data-key');
      if (line.getAttribute('data-lb-sgl-done') === '1') return;
      var sib = line.nextElementSibling;
      if (sib && sib.classList.contains('lb-sgl') && sib.getAttribute('data-lb-for') === key) return;
      pending = true;
    });
    if (!pending) return;
    busy = true;
    getCart().then(function (cart) {
      busy = false;
      if (!cart || !cart.items) return;
      var tbody2 = document.querySelector('cart-drawer-component .cart-items__table tbody');
      if (!tbody2) return;
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.handle] = true; });
      var byKey = {};
      cart.items.forEach(function (it) { byKey[it.key] = it; });
      var wanted = null;
      try { wanted = window.sessionStorage.getItem(NEXT_KEY); } catch (e) { }
      var groups = [];
      /* LB-LW-ONLY v2 05/09: 1 block duy nhat, gan vao item SERIES tren cung.
         Uu tien VI cung artwork (Long Wallet > Wallet > Mini Wallet).
         - Artwork da co vi trong gio, hoac chinh item la vi -> khong hien gi.
         - Artwork KHONG co vi nao -> fallback 1 mon 'From the same shelf'
           (uu tien vi cua artwork khac cung ke). Item khac/ben duoi: khong block. */
      var WALLET_PRI = ['Long Wallet', 'Wallet', 'Mini Wallet'];
      var anchored = false;
      tbody2.querySelectorAll('tr.cart-items__table-row[data-key]').forEach(function (line) {
        var key = line.getAttribute('data-key');
        if (line.getAttribute('data-parent-key')) return;
        var sib = line.nextElementSibling;
        var hasSib = sib && sib.classList.contains('lb-sgl') && sib.getAttribute('data-lb-for') === key;
        var item = byKey[key];
        var me = item ? IDX.byHandle[item.handle] : null;
        if (anchored || !me) { if (!hasSib) line.setAttribute('data-lb-sgl-done', '1'); return; }
        anchored = true; /* item series dau tien = anchor duy nhat */
        if (WALLET_PRI.indexOf(me.ty) >= 0) { line.setAttribute('data-lb-sgl-done', '1'); return; }
        var fam = IDX.fams[me.f] || [];
        var wallets = fam.filter(function (m) { return WALLET_PRI.indexOf(m.ty) >= 0 && m.h !== item.handle; })
          .sort(function (a, b) { return WALLET_PRI.indexOf(a.ty) - WALLET_PRI.indexOf(b.ty); });
        if (wallets.some(function (m) { return inCart[m.h]; })) { line.setAttribute('data-lb-sgl-done', '1'); return; }
        var cands = wallets.slice(0, 1), shelf = false;
        if (!cands.length && me.cl && me.cl.length) {
          /* quet ca ke lay VI truoc (LW > Wallet > Mini); ke khong co vi nao
             thi moi lay dai dien bat ky tu shelfCands */
          var pool = [];
          Object.keys(IDX.byHandle).forEach(function (h2) {
            var e2 = IDX.byHandle[h2];
            if (h2 === item.handle || e2.f === me.f || inCart[h2]) return;
            if (WALLET_PRI.indexOf(e2.ty) < 0) return;
            if (!e2.cl || !e2.cl.some(function (ci) { return me.cl.indexOf(ci) >= 0; })) return;
            var m2 = (IDX.fams[e2.f] || []).filter(function (x) { return x.h === h2; })[0];
            if (m2) pool.push({ h: m2.h, t: m2.t, ty: m2.ty, vid: m2.vid, p: m2.p, img: m2.img, f: e2.f });
          });
          for (var i2 = pool.length - 1; i2 > 0; i2--) { var j2 = Math.floor(Math.random() * (i2 + 1)); var t2 = pool[i2]; pool[i2] = pool[j2]; pool[j2] = t2; }
          pool.sort(function (a, b) { return WALLET_PRI.indexOf(a.ty) - WALLET_PRI.indexOf(b.ty); });
          cands = pool.slice(0, 1);
          if (!cands.length) cands = shelfCands(me, item.handle, inCart, {}).slice(0, 1);
          shelf = cands.length > 0;
        }
        if (!cands.length) { line.setAttribute('data-lb-sgl-done', '1'); return; }
        if (hasSib) return;
        groups.push({ line: line, key: key, fam: me.f, anchorTy: me.ty, cands: cands, shelf: shelf });
      });
      if (!groups.length) return;
      ensureCss();
      var openKey = groups[0].key;
      if (wanted && groups.some(function (g) { return g.key === wanted; })) openKey = wanted;
      try { window.sessionStorage.removeItem(NEXT_KEY); } catch (e) { }
      groups.forEach(function (g, gi) {
        var tr = document.createElement('tr');
        tr.className = 'lb-sgl';
        tr.setAttribute('data-lb-for', g.key);
        var td = document.createElement('td');
        td.colSpan = 5;
        var box = document.createElement('div');
        box.className = 'lb-sgl__box';
        var open = g.key === openKey;
        var chip = document.createElement('button');
        chip.type = 'button'; chip.className = 'lb-sgl__chip';
        chip.textContent = (open ? '\u25be ' : '\u25b8 ') + (g.shelf ? 'From the same shelf' : ('Matches your ' + ((SGL_SHORT[g.anchorTy]||'piece').toLowerCase())));
        box.appendChild(chip);
        var rows = document.createElement('div');
        if (!open) rows.hidden = true;
        g.cands.forEach(function (m) {
          var row = document.createElement('div');
          row.className = 'lb-sgl__row';
          row.innerHTML = '<span class="lb-sgl__thumb"><img loading="lazy" alt=""></span>' +
            '<span class="lb-sgl__mid"><p class="lb-sgl__name"></p><p class="lb-sgl__desc"></p></span>' +
            '<span class="lb-sgl__price"><span class="lb-sgl__pay"></span><s class="lb-sgl__was"></s></span>' +
            '<button type="button" class="lb-sgl__add">Add</button>';
          row.querySelector('img').src = m.img;
          row.querySelector('img').alt = m.t;
          row.querySelector('.lb-sgl__name').textContent = SGL_SHORT[m.ty] || m.ty;
          row.querySelector('.lb-sgl__desc').textContent = g.shelf ? ('\u201c' + String(m.f).replace(/["\u201c\u201d]/g, '') + '\u201d') : (SGL_DESC[m.ty] || 'Same artwork');
          row.querySelector('.lb-sgl__pay').innerHTML = fmt(half(m.p));
          row.querySelector('.lb-sgl__was').innerHTML = fmt(m.p);
          row.__lbM = m;
          var btn = row.querySelector('.lb-sgl__add');
          btn.addEventListener('click', function () {
            var next = groups[(gi + 1) % groups.length];
            if (next && next.key !== g.key) { try { window.sessionStorage.setItem(NEXT_KEY, next.key); } catch (e) { } }
            addItem(m.vid, btn, g.shelf ? 'Cart drawer \u2014 Same shelf' : null);
          });
          rows.appendChild(row);
        });
        box.appendChild(rows);
        chip.addEventListener('click', function () {
          var hide = !rows.hidden;
          rows.hidden = hide;
          chip.textContent = (hide ? '▸ ' : '▾ ') + chip.textContent.slice(2);
        });
        td.appendChild(box);
        tr.appendChild(td);
        g.line.after(tr);
      });
      fixPresRows();
    });
  }

  /* Nen footer drawer: an accordion "Discount"+form (hien khi bam "+ Add code"),
     chip mang luon so tien giam, gop 3 hang gia thanh 1 (gia goc gach ngang),
     note thue thu nho. Idempotent — chay lai sau moi morph, khong ghi DOM khi da dung. */
  function decorateFooter() {
    var sum = document.querySelector('cart-drawer-component .cart-drawer__summary');
    if (!sum) return;
    ensureCss();
    sum.classList.add('lb-cf');
    var det = sum.querySelector('accordion-custom.cart-discount details');
    if (det && !det.hasAttribute('open')) det.setAttribute('open', '');
    var comp = sum.querySelector('cart-discount-component');
    if (comp && !comp.querySelector('.lb-cf-addcode')) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lb-cf-addcode';
      b.addEventListener('click', function () {
        sum.classList.toggle('lb-cf-open');
        var isOpen = sum.classList.contains('lb-cf-open');
        b.textContent = (isOpen ? '\u25be' : '\u25b4') + ' Add code';
        if (isOpen) {
          var inp = sum.querySelector('.cart-discount__input');
          if (inp) setTimeout(function () { inp.focus(); }, 60);
        }
      });
      comp.appendChild(b);
    }
    var lnk = comp && comp.querySelector('.lb-cf-addcode');
    if (lnk) {
      var want = (sum.classList.contains('lb-cf-open') ? '\u25be' : '\u25b4') + ' Add code';
      if (lnk.textContent !== want) lnk.textContent = want;
    }
    var pillsAll = sum.querySelectorAll('.cart-discount__pill');
    var discVal = sum.querySelector('.cart-discounts__value');
    var amtsMap = window.__lbDiscAmts || null;
    for (var pIdx = 0; pIdx < pillsAll.length; pIdx++) {
      var pillEl = pillsAll[pIdx];
      var codeUp = (pillEl.getAttribute('data-discount-code') || '').toUpperCase();
      var amt = amtsMap ? (amtsMap[codeUp] || '') : ((pillsAll.length === 1 && discVal) ? discVal.textContent.trim() : '');
      var tag = pillEl.querySelector('.lb-chipamt');
      if (!amt) { if (tag && tag.parentNode) tag.parentNode.removeChild(tag); continue; }
      if (!tag) {
        tag = document.createElement('span'); tag.className = 'lb-chipamt';
        var rm = pillEl.querySelector('.cart-discount__pill-remove');
        if (rm && rm.parentNode === pillEl) pillEl.insertBefore(tag, rm); else pillEl.appendChild(tag);
      }
      if (tag.textContent !== amt) tag.textContent = amt;
    }
    var containers = sum.querySelectorAll('.cart-totals__original-container');
    for (var ci = 0; ci < containers.length; ci++) {
      var box = containers[ci];
      var rows = box.querySelectorAll('.cart-totals__original');
      if (rows.length < 2) continue;
      var totalVal = rows[0].querySelector('.cart-totals__original-value');
      var subRow = rows[rows.length - 1];
      var subVal = subRow.querySelector('.cart-totals__original-value');
      if (!totalVal || !subVal) continue;
      /* 18/09: gach bang tong gia goc truoc MOI ma (summer26.js tinh tu cart.js) neu co, thay vi "original" cua theme
         (= sau ma product-class, 135.85) — cho khop voi so gach o dong san pham (142.99). */
      var tv = (window.__lbOrigTotalText || totalVal.textContent.trim()), sv = subVal.textContent.trim();
      var st = subRow.querySelector('.lb-strike');
      if (tv && tv !== sv) {
        if (!st) { st = document.createElement('s'); st.className = 'lb-strike'; subVal.parentNode.insertBefore(st, subVal); }
        if (st.textContent !== tv) st.textContent = tv;
      } else if (st) st.remove();
    }
  }
  function schedule() {
    if (t) clearTimeout(t);
    t = setTimeout(function () { inject(); decorateFooter(); }, 220);
  }

  /* Badge guard da chuyen vao INLINE script trong snippets/header-actions.liquid
     (HTML-embedded de mien nhiem stale-asset 304/ETag). O day chi delegate. */
  function syncBadges(force) { if (window.__lbBadgeGuardSync) window.__lbBadgeGuardSync(force); }

  function boot() {
    syncBadges();
    ensureCss(); /* FOUC fix: style phai co TRUOC lan render footer dau tien */
    var host = document.querySelector('cart-drawer-component');
    if (!host) return;
    document.addEventListener('cart:update', function () { setTimeout(decorateFooter, 80); setTimeout(decorateFooter, 400); setTimeout(decorateFooter, 1200); });
    document.addEventListener('discount:update', function () {
      setTimeout(decorateFooter, 300);
      var s = document.querySelector('.cart-drawer__summary.lb-cf-open');
      if (s) s.classList.remove('lb-cf-open');
    });
    try { decorateFooter(); } catch (e) {}
    if (!IDX_URL) {
      var setp = document.getElementById('lb-setp');
      IDX_URL = setp ? setp.getAttribute('data-index-url') : null;
    }
    if (!IDX_URL) return;
    fetch(IDX_URL, { cache: 'force-cache' })
      .then(function (r) { return r.json(); })
      .then(function (idx) {
        if (!idx || !idx.byHandle) return;
        IDX = idx; PCT = idx.pct || 50;
        schedule();
        document.addEventListener('cart:update', function () { schedule(); setTimeout(inject, 700); });
        document.addEventListener('discount:update', schedule);
        new MutationObserver(function (recs) {
          for (var i = 0; i < recs.length; i++) {
            var tg = recs[i].target;
            if (tg && tg.nodeType === 1 && tg.closest && tg.closest('cart-drawer-component')) { schedule(); return; }
            var ad = recs[i].addedNodes;
            for (var j = 0; j < ad.length; j++) {
              var n = ad[j];
              if (n.nodeType === 1 && ((n.matches && n.matches('cart-drawer-component')) || (n.querySelector && n.querySelector('cart-drawer-component')))) { schedule(); return; }
            }
          }
        }).observe(document.body, { childList: true, subtree: true });
      })
      .catch(function () { });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
